import * as React from 'react';
import { useRef, useState } from 'react';
import styled from '@emotion/styled';
import { ButtonType, ButtonWidget } from '../../../../../widgets/buttons/ButtonWidget';
import { Routes, useJourneyNavigation } from '../../../../../routes';
import { SmartDropdownWidget } from '../../../../../widgets-smart/SmartDropdownWidget';
import { PlanModel } from '@journeyapps-platform/lib-journey-core';
import { useSystem } from '../../../../../hooks/useSystem';

export interface PlanOptionsWidgetProps {
  plan: PlanModel;
}

export const PlanOptionsDropdown: React.FC<{
  position: { x: number; y: number };
  plan: PlanModel;
  close: () => any;
}> = ({ position, close, plan }) => {
  const { navigate } = useJourneyNavigation(Routes.MANAGE_APPS);
  const system = useSystem();

  const { x, y } = position;
  return (
    <SmartDropdownWidget
      pos={{ x: x, y: y }}
      onClickOutside={close}
      items={[
        {
          label: 'Update card',
          icon: 'credit-card',
          action: async () => {
            navigate(Routes.PLAN_CARD_SETTINGS, {
              plan_id: plan.model.id,
              org_id: plan.model.org_id
            });
          }
        },
        {
          label: 'Cancel subscription',
          icon: 'cancel',
          enabled: !!plan.model.downgrade_blueprint && !plan.model.cancellation_requested_at,
          action: async () => {
            let cancel = await system.dialogStore.confirmDialog({
              title: 'Cancel subscription?',
              message: `An account representative will be notified, and will reach out to you as soon as possible.

               You can also contact us directly at support@journeyapps.com.`
            });
            if (!cancel) {
              return;
            }
            try {
              await system.clientProvisioner.provisionChargingStationClient().cancelPlanV2({
                plan_id: plan.id
              });
              system.dialogStore.confirmDialog({
                title: 'Request submitted',
                message: `Please note that you will no longer be charged as we process this request.`
              });
            } catch (ex) {
              await system.dialogStore.errorDialog({
                title: 'Oops! Something went wrong',
                errorMessage: 'Please contact support'
              });
            }
            plan.org.loadPlans();
          }
        }
      ]}
    />
  );
};

export const PlanOptionsWidget: React.FC<PlanOptionsWidgetProps> = (props) => {
  const [show, setShow] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  return (
    <>
      <ButtonWidget
        type={ButtonType.SECONDARY}
        icon="gear"
        forwardRef={ref}
        action={() => {
          const bounds = ref.current!.getBoundingClientRect();
          setPosition({
            x: bounds.x,
            y: bounds.y + 40
          });
          setShow(true);
        }}
      />
      {show ? <PlanOptionsDropdown plan={props.plan} close={() => setShow(false)} position={position} /> : null}
    </>
  );
};
namespace S {
  export const Container = styled.div``;
}
